import {ShowMoreText} from '../components/ShowMoreText'

export default class Registration {
    init() {

        const config = {
            //team member text
            jsMemberTextTrigger: $('.js-member-text-trigger'),
            jsTeamMemberSummery: $('.js-team-member-summary'),
            jsTeamMemberDetails: $('.js-team-member-details')

        };
        const showMoreText = new ShowMoreText(config);
        showMoreText.init();

        }

    }




// WEBPACK FOOTER //
// ./static/js/pages/Team.js